import { isNullOrUndef } from '../../utils/isNullOrUndef';
export const vNodeUnmount = (vNode) => {
    if (isNullOrUndef(vNode._el))
        return;
    if (vNode.type === 'ELEMENT') {
        vNode.lifeEvents.willUnmount?.(vNode._el);
        vNode.lifeEvents.willUnmount = undefined;
        vNode.children.forEach(vNodeUnmount);
    }
    vNode._el.remove();
    vNode._el._vNode = undefined;
    vNode._el = undefined;
    if (vNode.type === 'ELEMENT') {
        vNode.lifeEvents.didUnmount?.();
        vNode.lifeEvents.didUnmount = undefined;
    }
};
